<template>
  <div class="goals-wrapper">
    <details>
      <summary @click="openAccordion" id="goal-summary">
        <span class="summary-wrapper">
          <Warning color="#ffc938" v-if="!hasExistingGoal"></Warning>
          <Check color="#00B0AA" v-else></Check>
          <span v-if="hasExistingGoal">View or update your steps goal</span>
          <span v-else>Set your steps goal</span>
        </span>

        <span class="arrow">
          <Arrow color="#fff"></Arrow>
        </span>
      </summary>

      <div class="details-content">
        <form @submit.prevent="submitForm">
          <div class="field">
            <label for="walking-time-goal">
              <span>How many minutes do you hope to walk each day?</span>

              <input
                type="number"
                name="walking-time-goal"
                min="0"
                v-model="form.walkingTimeGoal"
                required
              />
            </label>
          </div>

          <button class="button button--standard" type="submit">
            <span v-if="existingGoal">Update steps goal</span>
            <span v-else>Set steps goal</span>
          </button>
        </form>
      </div>
    </details>
    <hr />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import Utility from "@/mixins/utility";

import Warning from "@/components/svg/Warning.vue";
import Arrow from "@/components/svg/Arrow.vue";
import Check from "@/components/svg/Check.vue";

import "firebase/compat/firestore";

export default {
  name: "Goals",

  data() {
    return {
      existingGoal: {},
      editStepsGoals: false,
      hasExistingGoal: false,

      form: {
        walkingTimeGoal: 0,
      },
    };
  },

  components: {
    Warning,
    Arrow,
    Check,
  },

  mixins: [Utility],

  async mounted() {
    // Check for existing goal.
    await this.checkforGoal();

    if (this.hasExistingGoal) {
      // Set existing goal as our form data.
      this.form = this.existingGoal.data().data;
    }
  },

  computed: {
    ...mapGetters(["getDB", "getUID"]),

    goalSections() {
      return Object.entries(this.form);
    },
  },

  methods: {
    ...mapMutations(["modifyLoading"]),

    async submitForm() {
      // Set loading to true.form
      this.modifyLoading(true);

      // Check for an existing document.
      await this.checkforGoal();

      // Check to see if a goal currently exists.
      if (this.hasExistingGoal) {
        // Update current goal.
        await this.updateGoal(this.existingGoal.id);
      } else {
        // Create new goal document for the user.
        await this.createGoal();
      }

      // Disable the loading spinner.
      this.disableLoader(1000);
    },

    // Checks to see if any existing goal is present and stores it.
    checkforGoal() {
      return this.getDB
        .collection("goals")
        .where("module", "==", "steps")
        .where("user", "==", this.getUID)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.existingGoal = doc;
            this.hasExistingGoal = true;
          });
        })
        .catch((error) => {
          this.hasExistingGoal = false;
        });
    },

    updateGoal(id) {
      const goalData = this.existingGoal.data();

      // Add in our new data.
      goalData.data = this.form;

      // Make the update.
      return this.getDB.collection("goals").doc(id).update(goalData);
    },

    // Creates a goal entry.
    createGoal() {
      return this.getDB.collection("goals").add({
        user: this.getUID,
        module: "steps",
        data: this.form,
      });
    },
  },
};
</script>

<style scoped>
header {
  font-weight: 600;
  margin-bottom: 1rem;
}
button {
  margin-top: 1rem;
}
summary {
  align-items: center;
  background-color: #002b4c;
  display: flex;
  justify-content: space-between;
}
summary svg {
  margin-right: 1rem;
}
.summary-wrapper {
  align-items: center;
  display: flex;
}
.goals-wrapper {
  margin-bottom: 2rem;
}
.details-content {
  padding: 2rem;
}
.goal-section {
  margin-bottom: 2rem;
}
.goal-group-header {
  font-weight: 600;
  text-transform: uppercase;
}
.goal {
  margin-bottom: 0.5rem;
}
</style>
